import type { FC } from 'react';
import { Controller } from 'react-hook-form';
import { SearchableInputSelect } from '@components/SearchableInputSelect';
import { ResourceState } from '@domain/schemas/contract.schema';
import { useSubmissions } from '@queries/fetchSubmissions';
import { isEmptyValue } from '@root/helpers';
import { type SubmissionShort } from '@src/queries';

import type { StepProps } from '../types';
import { resetForParentSubmission } from '../utils';

function filterFinalSubmissions(item: SubmissionShort) {
  return !isEmptyValue(item.name) && item.status === ResourceState.FINAL;
}

export const Step0: FC<StepProps> = ({ control, formValues, reset }) => {
  const { data: submissions = [], isLoading } = useSubmissions();

  const finalSubmissions = submissions.filter(filterFinalSubmissions).map((item) => ({
    name: item.name,
    value: item.id,
  }));

  return (
    <Controller
      control={control}
      name="parentSubmissionId"
      render={({ field, fieldState: { error } }) => (
        <SearchableInputSelect
          {...field}
          isLoading={isLoading}
          labelText="Select the contract to endorse"
          placeholder="Search contracts"
          options={finalSubmissions}
          value={formValues.parentSubmissionId}
          onChange={(value) => {
            field.onChange(value);
            resetForParentSubmission(reset, value as string | undefined);
          }}
          noOptionsLeftLabel="No contracts available"
          errors={error?.message}
          dataTestId="select:parentSubmissionId"
        />
      )}
    />
  );
};
